import { render, staticRenderFns } from "./PasswordLogin.vue?vue&type=template&id=bb47e02c&"
import script from "./PasswordLogin.vue?vue&type=script&lang=js&"
export * from "./PasswordLogin.vue?vue&type=script&lang=js&"
import style0 from "./PasswordLogin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports